import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BottomNav from './BottomNav';
import { LogOut, Settings, User, Bell, MessageSquare } from 'lucide-react';

export default function Layout({ children, title, showBack = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="page-container bg-[#F8FAFC]">
      {/* Top Header */}
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-xl border-b border-[#E2E8F0] safe-top" data-testid="app-header">
        <div className="flex items-center justify-between px-4 py-3 max-w-lg mx-auto">
          <div className="flex items-center gap-3 min-w-0">
            <h1 className="font-['Barlow_Condensed'] text-base sm:text-lg font-bold tracking-tight italic text-[#0A2242] flex items-center gap-2 truncate">
              {showBack && (
                <button onClick={() => navigate(-1)} className="text-[#64748B] hover:text-[#0A2242] transition-colors flex-shrink-0 p-1 -ml-1" data-testid="back-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                </button>
              )}
              {title ? <span className="truncate">{title}</span> : <img src="/logo-coach-phone.png" alt="Elev802 Connected" className="h-7 sm:h-8 w-auto rounded" />}
            </h1>
          </div>
          <div className="flex items-center gap-1 flex-shrink-0">
            {user?.role === 'player' && (
              <>
                <button
                  onClick={() => navigate('/messages')}
                  className="p-2 text-[#94A3B8] hover:text-[#0A2242] transition-colors"
                  data-testid="messages-btn"
                >
                  <MessageSquare size={18} strokeWidth={2.5} />
                </button>
                <button
                  onClick={() => navigate('/profile')}
                  className="p-2 text-[#94A3B8] hover:text-[#0A2242] transition-colors"
                  data-testid="profile-btn"
                >
                  <User size={18} strokeWidth={2.5} />
                </button>
              </>
            )}
            {user?.role === 'coach' && (
              <button
                onClick={() => navigate('/coach/players')}
                className="p-2 text-[#94A3B8] hover:text-[#0A2242] transition-colors"
                data-testid="players-btn"
              >
                <Settings size={18} strokeWidth={2.5} />
              </button>
            )}
            <button
              onClick={logout}
              className="p-2 text-[#94A3B8] hover:text-[#EF4444] transition-colors"
              data-testid="logout-btn"
            >
              <LogOut size={18} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-lg mx-auto">
        {children}
      </main>

      <BottomNav />
    </div>
  );
}
